import { render, staticRenderFns } from "./Companys.vue?vue&type=template&id=f2713306&scoped=true"
import script from "./Companys.vue?vue&type=script&lang=js"
export * from "./Companys.vue?vue&type=script&lang=js"
import style0 from "./Companys.vue?vue&type=style&index=0&id=f2713306&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2713306",
  null
  
)

export default component.exports